export default "__VITE_ASSET__f76a3b49__"